module.exports = __webpack_public_path__ + "static/media/general_purchase.ffbcedda.png";